var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('block-item-card',{attrs:{"min-height":310,"title":_vm.$t('Dashboard.Block.Survey.Title')}},[_c('survey-list-card',{attrs:{"items":_vm.items},on:{"survey-item-click":_vm.saveSurvey}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }